// extracted by mini-css-extract-plugin
export default {"hint":"Quiz_hint__UeZQ3","item":"Quiz_item__1u5w7","reset":"Quiz_reset__3OBlQ"};